<template>

  <div class="container">

    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">商家名称:</span>
          <!-- 搜索司机名称-->
          <el-input v-model="search_data.shop_name" placeholder="请输入商家名称" style="width: 200px;"
            @keyup.enter.native="searchipcShoppingLists">
          </el-input>
        </el-col>


      </el-row>



      <el-button type="primary" icon="el-icon-search" @click="searchipcShoppingLists">搜索</el-button>
      <el-button @click="addIpcShopping_show = !addIpcShopping_show">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->


            <el-form-item label="商家简介:">
              <span>{{ props.row.description }}</span>
            </el-form-item>

            <el-form-item label="	系统备注:">
              <span>{{ props.row.remarks }}</span>
            </el-form-item>



            <el-form-item label="商家物料备注:">
              <span>

                {{ props.row.materiel_remarks }}

              </span>
            </el-form-item>

            <el-form-item label="	创建时间:">
              <span>{{ props.row.time.YmdHis }}</span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>







      <el-table-column prop="shop_name" label="商家名称">
      </el-table-column>

      <el-table-column prop="phone" label="商家电话">
      </el-table-column>

      <el-table-column prop="shop_img" label="商家图片">
        <template scope="scope">
          <el-image style="width: 80px; height: 80px;border: 1px solid #eee;border-radius: 5px;"
            :src="scope.row.shop_img.url">
          </el-image>
        </template>
      </el-table-column>


      <el-table-column prop="day_out_num" label="商家每日单量">
      </el-table-column>

      <el-table-column prop="driver_num" label="推荐司机数量">
      </el-table-column>




      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>


      <el-table-column label="操作">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="editIpcShopping_show = !editIpcShopping_show; editIpcShopping_data = scope.row.ipc_shopping_code; "
            trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="del(scope.row.ipc_shopping_code)">删除</el-dropdown-item>

            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


    <!-- 添加组件 -->
    <addIpcShopping :isShow="addIpcShopping_show" @onSubmit="ipcShoppingLists"></addIpcShopping>



    <!-- 编辑组件 -->
    <editIpcShopping :isShow="editIpcShopping_show" :data="editIpcShopping_data" @onSubmit="ipcShoppingLists">
    </editIpcShopping>

  </div>

</template>

<script>
  import addIpcShopping from './addIpcShopping.vue';
  import editIpcShopping from './editIpcShopping.vue';
  var _this;
  export default {
    components: {
      addIpcShopping,
      editIpcShopping
    },


    data() {
      return {


        addIpcShopping_show: false,
        editIpcShopping_show: false,
        editIpcShopping_data: '',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          shop_name: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.ipcShoppingLists();
    },

    methods: {
      del(code) {

        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {


          _this.$post(
            "/admin.php/Business/deleteIpcShoppingSubmit", {
              ipc_shopping_code: code
            }
          ).then(res => {

            _this.$message.success(res.msg);
            _this.ipcShoppingLists();

          }).catch((err) => {

          })





        }).catch(() => {

          _this.$message({
            message: '已取消删除',
            duration: 1500
          });

        });

      },



      searchipcShoppingLists() {

        _this.search_data.page = 1;
        _this.ipcShoppingLists();

      },
      // 搜索司机日志列表
      ipcShoppingLists() {
        _this.$post(
            "/admin.php/Business/ipcShoppingLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.ipcShoppingLists();

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>